import React, { useEffect, useState } from "react";
import { selectSavedInstruments } from "../../../../../slices/SavedInstrumentSlice";
import { useDispatch, useSelector } from "react-redux";
import OrComponent from "../../../../resuableComponents/orUIComponent/OrComponent";
import UpiVpa from "../UpiVpa";
import ViewSavedInstrumentsHeader from "../../../modals/viewSavedInstrumentsModal/ViewSavedInstrumentsHeader";
import {
  changeActivePaymentMethod,
  changePaymentMethodInfo,
  selectActivePaymentMethod,
} from "../../../../../slices/PaymentButtonSlice";
import UpiQr from "../UpiQr";
import { getUpiVariant } from "../upiVariantConfig";

const UpiWeb = ({ upiMethodInfo, variant = "upi" }) => {
  const cfg = getUpiVariant(variant);
  const [upiCollectInstruments, setUpiCollectInstruments] = useState([]);
  const activePaymentMethod = useSelector((state) =>
    selectActivePaymentMethod(state)
  );
  const dispatch = useDispatch();
  const savedInstruments = useSelector((state) =>
    selectSavedInstruments(state)
  );

  let upiCollect = upiMethodInfo?.find(
    (upiInfo) => upiInfo.brand === cfg.collectBrand
  );
  let upiOr = upiMethodInfo?.find((upiInfo) => upiInfo.brand === cfg.qrBrand);
  useEffect(() => {
    if (savedInstruments) {
      let upiCollect = savedInstruments?.filter(
        (instrumentInfo) => instrumentInfo?.brand === cfg.collectBrand
      );
      setUpiCollectInstruments(upiCollect);
    }
  }, [savedInstruments]);

  useEffect(() => {
    dispatch(changePaymentMethodInfo(upiCollect));
  }, [activePaymentMethod]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {upiOr && (
        <>
          <UpiQr upiData={upiOr} variant={variant} />
        </>
      )}
      {upiOr && upiCollectInstruments?.length > 0 && <OrComponent />}

      {upiCollectInstruments?.length > 0 && (
        <div>
          <ViewSavedInstrumentsHeader
            data={upiCollectInstruments}
            title={"Saved UPI"}
            type={"Upi"}
            showInlinePayButton
          />
        </div>
      )}

      {upiCollect && (upiOr || upiCollectInstruments?.length > 0) && (
        <OrComponent />
      )}

      {upiCollect && (
        <>
          {/* <UpiVpa upiData={upiCollect} variant={variant} /> */}
        </>
      )}
    </div>
  );
};

export default UpiWeb;
